import { z } from 'zod';
import { Signal } from '../enums';
import { EvidenceItem } from '../scoring';
import { AssessmentDto } from './households';

export const SCORING_TESTS_PER_HOUR = 20;
export const SCORING_TEST_TIMEOUT_MS = 60_000;

export const ScoringTestInput = z.object({ householdId: z.string().uuid() });
export type ScoringTestInput = z.infer<typeof ScoringTestInput>;

export const SCORING_TEST_OUTCOMES = ['ok', 'invalid_output', 'provider_error', 'timeout'] as const;
export const ScoringTestOutcome = z.enum(SCORING_TEST_OUTCOMES);
export type ScoringTestOutcome = z.infer<typeof ScoringTestOutcome>;

export const CheckedEvidenceItem = EvidenceItem.extend({ verified: z.boolean() });
export type CheckedEvidenceItem = z.infer<typeof CheckedEvidenceItem>;

export const ScoringTestScore = z.object({
  score: z.number().int(),
  signals: z.array(Signal),
  evidence: z.array(CheckedEvidenceItem),
  rationale: z.string(),
  confidence: z.number(),
});
export type ScoringTestScore = z.infer<typeof ScoringTestScore>;

export const ScoringTestResult = z.object({
  promptVersion: z.string(),
  householdId: z.string().uuid(),
  familyLastName: z.string(),
  model: z.string(),
  latencyMs: z.number().int(),
  outcome: ScoringTestOutcome,
  error: z.string().nullable(),
  result: ScoringTestScore.nullable(),
  current: AssessmentDto.nullable(),
});
export type ScoringTestResult = z.infer<typeof ScoringTestResult>;
